import { safePusher } from '@owl-nest/shadow/src/ga/safePush.ts'

export const sendTrackingEvent = (eventCategory = '', eventAction = '', eventData = {}) => {
  if (eventCategory && eventAction) {
    dataLayer.push({
      event: 'GAevent',
      eventAction,
      eventCategory,
      nonInteractionEvent: undefined,
      ...eventData,
    })
  }
}

export const sendSocialTrackingEvent = (socialNetwork = '', socialAction = '', eventData = {}) => {
  if (socialNetwork && socialAction) {
    dataLayer.push({
      event: 'socialInt',
      ...eventData,
    })
  }
}

export const addTrackingListeners = () => {
  const projectProposalButtons = document.querySelectorAll('[data-gtm-click=project-proposal]')
  for (let i = 0; i < projectProposalButtons.length; i++) {
    projectProposalButtons[i].addEventListener('click', (event) => {
      sendTrackingEvent('Project proposal', 'click')
    })
  }
}

export const formTracker = (trackedFields) => {
  const [stateVariables, errorVariables] = Object.entries(trackedFields).reduce(
    (acc, [_, { value, error }]) => {
      acc[0][value] = 'empty'
      acc[1][error] = 'none'
      return acc
    },
    [{}, {}]
  )
  dataLayer.push(stateVariables)
  dataLayer.push(errorVariables)

  const state = {}

  const setState = (field, value) => {
    if (state[field] === value) return

    state[field] = value
    dataLayer.push({ event: 'GAevent', eventCategory: 'project_form', [trackedFields[field].value]: value })
  }

  const setters = Object.keys(trackedFields).reduce((acc, key) => {
    acc[key] = {
      setValue: (value) => setState(key, value),
      markFilled: () => setState(key, 'filled'),
      markEmpty: () => setState(key, 'empty'),
    }

    return acc
  }, {})

  const onError = (errors) => {
    const messages = {}
    for (const [field, message] of Object.entries(errors)) {
      if (message && trackedFields[field]) {
        const { error } = trackedFields[field]
        messages[error] = message
      }
    }
    if (Object.keys(messages).length !== 0) {
      dataLayer.push({
        event: 'projectFormError',
        ...messages,
      })
    }
  }

  const pushGA = ({ category, label, action }, callback) => {
    const event = {
      event: 'GAevent',
      eventAction: action,
      eventCallback: callback,
      eventCategory: category,
      eventLabel: label,
    }
    if (callback && !event.eventTimeout) {
      event.eventTimeout = 500
    }

    safePusher(window.UFE.gtmKey)(event)
  }

  const onSubmit = (category, label, callback) => {
    pushGA({ category, label, action: 'submit' }, callback)
  }

  return { ...setters, onError, onSubmit, pushGA }
}
